import React, { useEffect, useState } from "react";
import { PiggyBank, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { apiClient, formatApiError } from "@/lib/auth";

const usd = (v) => (v || 0).toLocaleString("en-US", { style: "currency", currency: "USD" });

/** Super admin: resident savings sitting in ...1403. Savings deposits/withdrawals after the save adjust it automatically. */
export const SavingsHeldTab = () => {
  const [d, setD] = useState(null);
  const [amt, setAmt] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    apiClient.get("/platform-settings/savings-held").then(({ data }) => { setD(data); setAmt(String(data.total)); }).catch((e) => toast.error(formatApiError(e)));
  }, []);
  if (!d) return <Loader2 className="h-4 w-4 animate-spin text-nex-muted" />;
  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data } = await apiClient.put("/platform-settings/savings-held", { amount: Number(amt) }); setD(data); setAmt(String(data.total)); toast.success(`Savings held in ...1403 set to ${usd(data.total)}`); }
    catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };
  return (
    <form onSubmit={save} data-testid="savings-held-card" className="card-industrial corner-tick p-6 md:p-8 max-w-3xl">
      <div className="flex items-center gap-3 mb-2"><PiggyBank className="text-nex-gold" size={20} /><div className="mono-label">// RESIDENT SAVINGS HELD IN ...1403</div></div>
      <p className="text-nex-chrome text-sm mb-6">The part of resident savings sitting in TEA-First Reliance ...1403. Shown as a liability on Bills &amp; Banking and subtracted from the usable ...1403 balance. Savings deposits and withdrawals after you save adjust it automatically.</p>
      <div className="grid sm:grid-cols-3 gap-3 text-sm mb-6">
        <div><div className="mono-label text-[10px]">Held now</div><div className="serif-head text-xl" data-testid="savings-held-current">{usd(d.total)}</div></div>
        <div><div className="mono-label text-[10px]">Set to</div><div data-testid="savings-held-baseline">{usd(d.baseline)} · {String(d.baseline_as_of).slice(0, 10)}</div></div>
        <div><div className="mono-label text-[10px]">Activity since</div><div data-testid="savings-held-change">{usd(d.change_since)}</div></div>
      </div>
      {d.can_edit ? (
        <div className="flex flex-wrap items-end gap-3">
          <label><span className="block font-mono text-[10px] uppercase tracking-wider text-nex-muted mb-1">Amount held in ...1403 today</span>
            <input data-testid="savings-held-input" type="number" step="0.01" min="0" required value={amt} onChange={(e) => setAmt(e.target.value)}
              className="w-48 px-3 py-2.5 bg-black/40 border border-white/10 focus:border-[#d4a017] outline-none text-sm text-white rounded-sm" /></label>
          <button data-testid="savings-held-save" type="submit" disabled={busy} className="tick-btn-primary inline-flex items-center gap-2 disabled:opacity-50">
            {busy && <Loader2 size={14} className="animate-spin" />} Save amount</button>
        </div>
      ) : <p className="text-xs text-nex-muted">Only super admins can change this.</p>}
    </form>
  );
};
